import styled from 'styled-components';

const Container = styled.div`
text-align: center;
  svg {
    width: 120px;
    height: 120px;
  }
  .resetHeading {
    font-size: 20px;
    margin-top: 0;
  }
`;


const Styled = { Container };
export default Styled;